export const sortByTotal = <
  T extends { totalCollateralUsd: number; totalDebtUsd: number } | null,
>(
  list: T[],
) => {
  const listCopy = [...list];
  return listCopy.sort((a, b) => {
    if (!a || !b) return 0;
    const availableFirst = a.totalCollateralUsd - a.totalDebtUsd;
    const availableSecond = b.totalCollateralUsd - b.totalDebtUsd;

    return availableSecond - availableFirst;
  });
};
